<template>
  <div class="contentBox">
    <div class="tableBox">
      <Tabs :tabs="tabsList" @tab-click="tabClick">
        <JRtable :table-data="complaintTableData" :selection="false" :column="complaintColumn" size="mini" @page-change="changePages" :pageOptions="pageInfo" :border="true" :index="true">
          <template slot="slot_record_tools" slot-scope="data">
            <el-button size="mini" type="primary" :disabled="tabActive === 1 ? true : false" @click="handleDelete(data.scope.row.tsid)">撤回投诉</el-button>
          </template>
        </JRtable>
      </Tabs>
    </div>
  </div>
</template>

<script>
import { getFactTsList, deleteFactTs, getTsztNumStatistics } from '@/api/enterprise/complaint'
import JRtable from '@/components/Table'
import Tabs from '@/components/Tabs'
import { mapGetters } from 'vuex'

export default {
  name: 'Complaint',
  components: {
    JRtable,
    Tabs
  },
  computed: {
    ...mapGetters(['tyshxydm'])
  },
  data() {
    return {
      complaintTableData: [],
      complaintColumn: [
        {
          label: '投诉服务名称',
          prop: 'fwmc',
          align: 'center',
          truncate: true
        },
        {
          label: '服务机构名称',
          prop: 'jgmc',
          align: 'center',
          truncate: true
        },
        {
          label: '投诉时间',
          prop: 'tssj',
          align: 'center',
          truncate: true
        },
        {
          label: '投诉用户',
          prop: 'tsyh',
          align: 'center',
          truncate: true
        },
        {
          label: '投诉说明',
          prop: 'tssm',
          align: 'center',
          truncate: true
        },
        {
          label: '投诉处理结果',
          prop: 'tscljg',
          align: 'center',
          truncate: true
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          slot: 'slot_record_tools'
        }
      ],
      // 顶部横向tabs切换栏目
      tabsList: [
        {
          id: 0,
          value: '待回复',
          isActive: true,
          quantity: 0
        },
        {
          id: 1,
          value: '已回复',
          isActive: false,
          quantity: 0
        }
      ],
      tabActive: 0,
      pageInfo: {
        limit: 10,
        page: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50]
      }
    }
  },
  created() {
    this.initList()
    this.getNum()
  },
  mounted() {},
  methods: {
    getNum() {
      const params = {
        tyshxydm: this.tyshxydm
      }
      getTsztNumStatistics(params).then((res) => {
        if (res.code === 200) {
          this.tabsList[0].quantity = res.data.dhf
          this.tabsList[1].quantity = res.data.yhf
        }
      })
    },
    initList() {
      const params = {
        page: this.pageInfo.page,
        size: this.pageInfo.limit,
        tyshxydm: this.tyshxydm,
        tszt: this.tabActive
      }
      getFactTsList(params).then((res) => {
        if (res.code === 200) {
          this.complaintTableData = res.data.records
          this.pageInfo.total = res.data.total
        }
      })
    },
    // 翻页
    changePages(page) {
      this.pageInfo.page = page.page
      this.initList()
    },
    tabClick(item) {
      this.tabActive = item.id
      this.initList()
    },
    // 撤回投诉
    handleDelete(id) {
      const params = {
        tsid: id
      }
      deleteFactTs(params).then((res) => {
        if (res.code === 200) {
          this.initList()
          this.getNum()
          this.$message({
            type: 'success',
            message: '撤回成功'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contentBox {
  width: 100%;
  height: 100%;
  .tableBox {
    margin-top: 25px;
  }
}

::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .el-tabs__nav-scroll {
  border-bottom: 2px solid #2968ff;
}
::v-deep .el-tabs__item {
  width: 107px;
  height: 40px;
  background: #ececec;
  font-family: SourceHanSansCN Normal;
  font-weight: 400;
  font-size: 16px;
  color: #00000099;
  text-align: center;
  padding-right: 0px;
  padding-left: 0px;
}
::v-deep .el-tabs__active-bar {
  display: none;
}
::v-deep .el-tabs__item.is-active {
  background: #2968ff;
  color: #fff;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  text-align: left;
}
::v-deep .el-table--mini {
  max-height: 580px;
  overflow-y: scroll;
}
</style>
